/** Sends an old System settings link (`/system-settings?tab=…`) to its section, for good. */
import { Navigate, useLocation } from 'react-router-dom';
import { legacySettingsTarget } from './legacy-settings-target';

export function LegacySettingsRedirect() {
  const { search } = useLocation();
  return <Navigate to={legacySettingsTarget(search)} replace />;
}
